import { reportError } from './frontend-logs';

export const cdnUrl = typeof window.cdnUrl === 'string' && window.cdnUrl ? window.cdnUrl : '';


export const reportAxiosError = (error) => {

    if (!error) {
        reportError('Empty Axios Error Object');
        return;
    }

    if (typeof error === 'object' && typeof error.message === 'string' && error.message == 'Network Error') {
        return;
    }

    reportError(error.message ?? 'Axios Error', {
        data: typeof error.response === 'object' && typeof error.response.data !== 'undefined' ? JSON.stringify(error.response.data) : null,
        error: JSON.stringify(error),
        url: location.href,
        userAgent: navigator.userAgent,
    });
};


export const getCSRFToken = () => {
    let token = document.head.querySelector('meta[name="csrf-token"]');

    if(!token) {
        return '';
    }

    return token.content;
};

export const colours = {

    // Basic Colours
    white:          '#fff',
    black:          '#111',
    grey:           '#eaeaea',
    blue:           '#439DDF',
    darkBlue:       '#30546a',
    darkestBlue:    '#203847',
    green:          '#7dd640',
    orange:         '#faa05a',
    red:            '#f0506e',

    // Specific Colours
    borderGrey: '#eaeaea',
    textColor: '#666',

};

export const getConnectionTitle = (key) => {
    switch(key) {

        case 'sms':
            return 'Text Message';

        case 'slack':
            return 'Slack';

        case 'google_calendar': // DEPRECATED
            return 'Google Calendar';

        case 'google_hangouts_chat':
            return 'Google Chat';

        case 'outlook_calendar': // DEPRECATED
            return 'Outlook Calendar';

        case 'facebook': // DEPRECATED
            return 'Facebook Messenger';

        case 'telegram': // DEPRECATED
            return 'Telegram';

        case 'discord':
            return 'Discord';

        case 'microsoft_teams':
            return 'Microsoft Teams';

    }

    return 'Unknown';
};

export const getResponseTitle = (key) => {
    switch(key) {

        case 'url':
            return 'Website Response';

        case 'manual':
            return 'Website Response';

        case 'sms':
            return 'Text Message';

        case 'slack':
            return 'Slack';

        case 'facebook_message':
            return 'Facebook Messenger';

        case 'telegram':
            return 'Telegram';

        case 'google_hangouts_chat':
            return 'Google Chat';

        case 'discord':
            return 'Discord';

        case 'microsoft_teams':
            return 'Microsoft Teams';

    }

    return 'Unknown';
};

export const getDeliveryFailureLabel = (resultCode) => {
    switch (resultCode) {

        case 'is_archived':
            return 'The selected Slack channel has been archived. Choose another channel in your Slack integration settings.';

        case 'channel_not_found':
            return 'The selected Slack channel could not be found. Choose another channel in your Slack integration settings.';

        case 'messages_tab_disabled':
            return 'Direct messages to this app are unavailable. Choose a Slack channel instead of a direct message in your integration settings.';

        case 'not_in_channel':
            return 'The bot has not been invited to this Slack channel. Invite the bot with /invite or choose another channel.';

        case 'restricted_action':
            return 'A workspace setting prevents the bot from posting to this Slack channel. Choose another channel or ask a workspace admin for help.';

        case 'restricted_action_read_only_channel':
            return 'This Slack channel is read-only. Choose another channel in your integration settings.';

        case 'restricted_action_thread_only_channel':
            return 'This Slack channel only allows replies in threads. Choose another channel in your integration settings.';

        case 'restricted_action_non_threadable_channel':
            return 'This Slack channel does not allow thread replies. Choose another channel in your integration settings.';

        case 'restricted_action_thread_locked':
            return 'The thread in this Slack channel has been locked. Choose another channel in your integration settings.';

        case 'no_connection':
            return 'Your Slack integration is not connected. Reconnect Slack in integration settings.';

        case 'no_auth':
            return 'Your Slack integration is no longer authorised. Reconnect Slack in integration settings.';

        case 'empty_message_channel_id':
            return 'No Slack channel is configured for reminders. Choose a channel in your Slack integration settings.';

        case 'no_billing_subscription':
            return 'Your subscription is not active, so messages could not be sent.';

        case 'no_plan_access':
            return 'Your plan does not include chat reminders.';

    }

    return '';
};

export const getConnectionRouterName = (key) => {
    switch(key) {

        case 'sms':
            return 'smsConnection';

        case 'slack':
            return 'slackConnection';

        case 'google_hangouts_chat':
            return 'googleHangoutsChatConnection';

        case 'discord':
            return 'discordConnection';

        case 'microsoft_teams':
            return 'microsoftTeamsConnection';

    }

    return '';
};

export const getReminderCycleStatusLabel = (isComplete, isActive, isScheduled, forceStopped, forceStoppedReason) => {
    let status  = '';
    let label   = '';

    if(forceStopped && forceStoppedReason) {
        switch(forceStoppedReason) {

            case 'reminder_deactivated':
                status  = 'deactivated';
                label   = 'Deactivated';
                break;

            case 'automatic_end':
                status  = 'ignored';
                label   = 'Ignored';
                break;

            case 'reminder_cycle_replaced':
            case 'user_skipped':
            case 'user_rescheduled':
                status  = 'rescheduled';
                label   = 'Rescheduled';
                break;

        }

    } else if(isComplete) {
        status  = 'complete';
        label   = 'Complete';

    } else if(isActive) {
        status  = 'in-progress';
        label   = 'In Progress';

    } else if(isScheduled) {
        status  = 'scheduled';
        label   = 'Scheduled';
    }

    return {
        status: status,
        label: label,
    };
};
